export default "__VITE_ASSET__CsfZqPMb__"